<template>
  <div v-if="show" class="show" v-bind:class="overlayClass">
    <div class="content" v-bind:class="classContent">
      <span v-if="label" class="label">{{ label }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      show: {
        type: Boolean,
        default: true
      },
      label: {
        type: String,
        required: false
      },
      overlay: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      classContent () {
        return {
          'withLabel': this.label,
          'withoutLabel': !this.label,
          'overlay': this.overlay
        }
      },
      overlayClass () {
        return {
          'overlay': this.overlay
        }
      }
    }
  }
</script>

<style lang="sass" scoped>
  .content
    width: 100%
    margin: auto
    height: 27px
    text-align: center
    position: absolute
    bottom: 0

    &:not(.overlay)
      left: 0
      right: 0
      margin-bottom: 20px

    &.overlay
      top: 0
      bottom: 0

  .withoutLabel
    height: 22px

  .v-spinner
    width: 90px
    margin: auto
    display: block
    vertical-align: middle

  .label
    display: block
    vertical-align: middle
    font-size: 20px
    font-weight: bold
    opacity: 0.5
    line-height: 28px

  div.show
    display: block
    width: 100%

    &.overlay
      top: 0
      left: 0
      height: 100%
      position: absolute
      background: rgba(250, 250, 250, 0.9)
      z-index: 2147483646
</style>



// WEBPACK FOOTER //
// Overlay.vue?743e8bf4